import React from 'react'
import { Col, Flex, Row, Typography } from 'antd'
import { UnderlineDesign } from '../UnderlineDesign'


const { Title, Text } = Typography
const Ourhistory = () => {
  return (
    <div className='padding-t'>
        <div className='container'>
            <Row gutter={[64, 24]} align={'middle'}>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <div>
                        <img src="assets/images/our-history.jpg" width={'100%'} className='rounded' alt="" />
                    </div>
                </Col>
                <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <Flex vertical gap={20}>
                        <Flex vertical>
                            <Title level={2} className='m-0 gradient-text'>Our History</Title>
                            <UnderlineDesign />
                        </Flex>
                        <Text className='fs-16 text-justify'>
                        What started as a small team passionate about quality service and community support has grown into a dynamic platform serving thousands of users across the region. From construction and plumbing to carpet cleaning and electrical work, we make it easy for clients to find licensed, vetted pros who get the job done right.
                        </Text>
                    </Flex>
                </Col>
            </Row>
        </div>
    </div>
  )
}

export {Ourhistory}